import { MailVerification as MailVerificationComponent } from "../components/verification/MailVerification";

const MailVerification = () => {
  return <MailVerificationComponent />;
};

export default MailVerification;
